module.exports = __webpack_public_path__ + "static/img/1.03ee49c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/1.jpeg
// module id = RHmn
// module chunks = 13